import { styled } from '@zoopla-eng/zds-components/themes';

export const NewHomesSectionTitle = styled('h1', {
    fontGroup: 'kettle',
    color: '$textTitle',
    fontWeight: '$semiBold'
});
